import {UserFollows} from '../resources/UserFollows';
import {EntityExportAvailableEvent} from './EntityExportAvailableEvent';

/**
 * This event can be fired to indicate that some data as requested via the {@see UserFollowsExportRequested} event is
 * available and can be processed.
 */
export class UserFollowsExportAvailable extends EntityExportAvailableEvent<UserFollows> {}
